/* src/app/front-layout/eleven-topic-test/eleven-topic-test.component.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family:
    "Segoe UI",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
  line-height: 1.6;
  color: #333;
  overflow-x: hidden;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.hero {
  background: white;
  color: #1B7A9F;
  padding: 100px 20px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><rect width="2" height="2" fill="white" opacity="0.1"/></svg>');
  opacity: 0.3;
}
.hero-content {
  position: relative;
  z-index: 1;
  margin-top: 100px;
}
.hero h1 {
  font-size: 4.5rem;
  margin-bottom: 20px;
  animation: fadeInUp 0.8s ease;
  color: #1B7A9F;
  font-weight: 700;
}
.hero p {
  font-size: 1.8rem;
  margin-bottom: 30px;
  opacity: 0.95;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  animation: fadeInUp 0.8s ease 0.2s backwards;
}
.cta-button {
  display: inline-block;
  background: #005f87;
  color: #ffffff;
  padding: 15px 40px;
  text-decoration: none;
  border-radius: 50px;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 191, 0, 0.4);
  animation: fadeInUp 0.8s ease 0.4s backwards;
}
.cta-button:hover {
  background: #e6ac00;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 191, 0, 0.6);
}
section {
  padding: 80px 20px;
}
section:nth-child(even) {
  background: #f8f9fa;
}
.section-title {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}
.section-subtitle {
  text-align: center;
  font-size: 2rem;
  color: #7f8c8d;
  margin-bottom: 50px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.topics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}
.topic-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}
.topic-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}
.topic-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
}
.topic-icon svg {
  width: 100%;
  height: 100%;
  fill: #005f87;
}
.topic-card h3 {
  color: #005f87;
  margin-bottom: 10px;
  font-size: 2rem;
}
.topic-card h3 {
  margin-bottom: 10px;
  font-size: 2rem;
}
.results-content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 40px;
}
.result-stat {
  text-align: center;
  flex: 1;
  min-width: 200px;
}
.result-stat .stat-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
}
.result-stat .stat-icon svg {
  width: 100%;
  height: 100%;
  fill: #FFBF00;
}
.result-stat h3 {
  font-size: 2rem;
  color: #005f87;
  margin-bottom: 10px;
}
.result-stat p {
  color: #7f8c8d;
  font-size: 1.5rem;
}
.schedule-timeline {
  max-width: 800px;
  margin: 40px auto;
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}
.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 2px solid #e9ecef;
}
.timeline-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.timeline-icon {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  min-width: 50px;
}
.timeline-icon svg {
  width: 100%;
  height: 100%;
  fill: #005f87;
}
.timeline-content h4 {
  color: #2c3e50;
  margin-bottom: 5px;
  font-size: 2.5rem;
}
.timeline-content p {
  color: #7f8c8d;
  font-size: 1.5rem;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}
.benefit-card {
  background:
    linear-gradient(
      135deg,
      #005f87 0%,
      #004a6b 100%);
  color: white;
  padding: 35px;
  border-radius: 15px;
  transition: transform 0.3s ease;
}
.benefit-card:hover {
  transform: scale(1.05);
}
.benefit-card .benefit-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.benefit-card .benefit-icon svg {
  width: 100%;
  height: 100%;
  stroke: #FFBF00;
}
.benefit-card h3 {
  margin-bottom: 10px;
  font-size: 1.8rem;
  color: white;
}
.benefit-card p {
  opacity: 0.9;
  line-height: 1.6;
}
.steps-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 40px;
}
.step {
  flex: 1;
  min-width: 250px;
  text-align: center;
  position: relative;
}
.step-number {
  width: 80px;
  height: 80px;
  background:
    linear-gradient(
      135deg,
      #005f87 0%,
      #004a6b 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 auto 20px;
  box-shadow: 0 5px 15px rgba(0, 95, 135, 0.4);
}
.step h3 {
  color: #2c3e50;
  margin-bottom: 10px;
}
.step p {
  color: #7f8c8d;
}
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}
.testimonial-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  position: relative;
}
.testimonial-card::before {
  content: '"';
  font-size: 4rem;
  color: #005f87;
  opacity: 0.2;
  position: absolute;
  top: 10px;
  left: 20px;
  font-family: Georgia, serif;
}
.testimonial-text {
  font-style: italic;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.8;
}
.testimonial-author {
  font-weight: 600;
  color: #005f87;
}
.faq-container {
  max-width: 800px;
  margin: 40px auto;
}
.faq-item {
  background: white;
  padding: 25px;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}
.faq-question {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  font-size: 2rem;
}
.faq-answer {
  color: #7f8c8d;
  line-height: 1.6;
  font-size: 1.5rem;
}
.footer-cta {
  background:
    linear-gradient(
      135deg,
      #005f87 0%,
      #004a6b 100%);
  color: white;
  padding: 60px 20px;
  text-align: center;
}
.footer-cta h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  font-weight: 600;
  color: white;
}
.ft-btn {
  background: #e6ac00;
  color: #005f87;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.weekly-session-container {
  font-family: Arial, sans-serif;
  max-width: 90%;
  margin: 40px auto;
}
.header {
  background-color: #F5C542;
  padding: 30px 20px;
  margin-bottom: 0;
}
.header h1 {
  color: #1B7A9F;
  font-size: 32px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}
.sessions-grid {
  background-color: #1B7A9F;
  padding: 20px 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
.session-card {
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.week-title {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.subject-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.subject-item {
  font-size: 15px;
  color: #333333;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
  .hero p {
    font-size: 1.1rem;
  }
  .section-title {
    font-size: 2rem;
  }
  .topics-grid,
  .benefits-grid {
    grid-template-columns: 1fr;
  }
  .steps-container {
    flex-direction: column;
  }
  .header h1 {
    font-size: 28px;
  }
  .sessions-grid {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=eleven-topic-test.component.css.map */
